// Implements: F-PRV-006
/**
 * The viewport the person last chose, remembered between visits.
 *
 * Per-viewer UI state and nothing else: one key whose value holds the mode and two numbers. No
 * identifier, no credential, no server data. Storage is a convenience and never a dependency:
 * both functions are wrapped in `try/catch` because a private window, blocked site data or a full
 * quota make the accessor itself throw, and a viewer that cannot remember must still work
 * (known-defect checklist 15).
 */
import { parseViewport } from "./viewport";
import type { ViewportState } from "./viewport";

export const VIEWPORT_KEY = "prototyper.preview.viewport";

export function readViewport(): ViewportState {
  try {
    return parseViewport(localStorage.getItem(VIEWPORT_KEY));
  } catch {
    return parseViewport(null);
  }
}

export function writeViewport(state: ViewportState): void {
  try {
    const { mode, freeWidth, zoom } = state;
    localStorage.setItem(VIEWPORT_KEY, JSON.stringify({ mode, freeWidth, zoom }));
  } catch {
    // Not remembering is the whole cost of a store that refuses.
  }
}
